<template>
    <div >
      <Card>
            <p slot="title">
                Bank Account
            </p>
                <Button
                    v-show="canCreateBankAccount()"
                    type="primary"
                    slot="extra"
                    @click="modal.createBankAccount=true"
                    size="small"  >
                    Tambah
                </Button>
                <template>
                        <Table border :columns="columnTableBankAccount" :data="bankAccount"></Table>

                </template>
        </Card>
        <template>
            <Modal v-model="modal.createBankAccount" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Tambah Bank Account</span>
                </p>
                        <Form ref="formBankAccount" :model="formBankAccount" :rules="ruleValidate">
                            <Form-item label="Account Name" prop="accountName">
                                <Input v-model="formBankAccount.accountName" placeholder="Account Name"></Input>
                            </Form-item>
                            <Form-item label="Divisions" prop="divisions">
                        <Select
                            placeholder="Ketik Division"
                            v-model="formBankAccount.division"
                            filterable
                            :remote-method="getDivision"
                            :loading="loadingGetDivision">
                            <Option v-for="(option, index) in optionDivisions"
                                :value="option.value" :key="index">{{option.label}}</Option>
                        </Select>
                    </Form-item>
                        </Form>
                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingCreateBankAccount"
                        @click="postCreateBankAccount" >
                        <span v-if="!loadingCreateBankAccount">Simpan</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
        <template>
            <Modal v-model="modal.updateBankAccount" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Edit Item</span>
                </p>
                <Form ref="formUpdateBankAccount" :model="formUpdateBankAccount" :rules="ruleValidate">
                    <Form-item label="Account Name" prop="accountName">
                        <Input style="display: none;" v-model="formUpdateBankAccount.id" placeholder="Id Account Name"></Input>
                        <Input v-model="formUpdateBankAccount.accountName" placeholder="Account Name"></Input>
                    </Form-item>
                    <Form-item label="Divisions" prop="divisions">
                        <Select
                            placeholder="Ketik Division"
                            v-model="formUpdateBankAccount.division"
                            filterable
                            :remote-method="getDivision"
                            :loading="loadingGetDivision">
                            <Option v-for="(option, index) in optionDivisions"
                                :value="option.value" :key="index">{{option.label}}</Option>
                        </Select>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingUpdateBankAccount"
                        @click="postUpdateBankAccount" >
                        <span v-if="!loadingUpdateBankAccount">Update</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
            <Modal v-model="modal.updateIsActiveToActive" @on-ok="updateIsActive" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Aktifkan</span>
                </p>
                <p>Anda yakin ingin mengaktifkan bank account "{{formUpdateBankAccount.accountName}}"?</p>
            </Modal>
            <Modal v-model="modal.updateIsActiveToNonActive" @on-ok="updateIsActive" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Non Aktifkan</span>
                </p>
                <p>Anda yakin ingin non aktifkan bank account "{{formUpdateBankAccount.accountName}}"?</p>
            </Modal>
        </template>
    </div>
</template>
<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'

export default {
    data () {
        return {
        user : {
            username : '',
            role : ''
        },
        modal : {
            createBankAccount : false,
            updateBankAccount : false,
            updateIsActiveToActive: false,
            updateIsActiveToNonActive: false,
        } ,
        loadingSearch: false,
        loadingCreateBankAccount: false,
        loadingUpdateBankAccount: false,
        bankAccount : [],
        formBankAccount: {
            accountName: '',
            division: '',
        },
        formUpdateBankAccount: {
            accountName: '',
            division: '',
        },
        ruleValidate: {
            accountName: [
                { required: true, message: 'Masukkan Account Name', trigger: 'blur' }
            ],
        },
        columnTableBankAccount: [
            {
                title: 'Account Name',
                key: 'accountName'
            },
            {
                title: 'Division',
                key: 'divisionName'
            },
            {
                title: 'Action',
                key: 'action',
                width: 180,
                align: 'center',
                render: (h, params) => {
                    let isActive = this.bankAccount[params.index].isActive;
                    let buttonToShow = [
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.show(params.index, 'updateBankAccount')
                                    }
                                }
                            }, 'Edit')
                    ];

                    if(isActive) {
                        buttonToShow.push(
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.show(params.index, 'updateIsActive')
                                    }
                                }
                            }, 'Non Aktifkan')
                        );
                    } else {
                        buttonToShow.push(
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.show(params.index, 'updateIsActive')
                                    }
                                }
                            }, 'Aktifkan')
                        );
                    }
                    return h('div', buttonToShow);
                }
            }
        ],
        loadingGetDivision: false,
        optionDivisions: [],
    }},

  methods: {
    canCreateBankAccount () {
        let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR'], this.user.role);
        return canAccess;
    },
    handleSubmit (name) {
        this.$refs[name].validate((valid) => {
            if (valid) {
                this.createbankAccount();
            } else {
                this.$Message.error('Data masih belum lengkap');
            }
        })
    },
    show: function(index, modalName){
        var updateBankAccountId = this.bankAccount[index].id;
        this.formUpdateBankAccount.id = updateBankAccountId;

        var updateAccountName = this.bankAccount[index].accountName;
        this.formUpdateBankAccount.accountName = updateAccountName;

        var updateIsActive = this.bankAccount[index].isActive;
        this.formUpdateBankAccount.isActive = updateIsActive;

        if(this.bankAccount[index].division != null) {
          let division_id = this.bankAccount[index].division.id
          let division_name = this.bankAccount[index].division.division_name
          this.formUpdateBankAccount.division = division_id
          this.optionDivisions = [
            {
              value: division_id,
              label: division_name
            }
          ]
        }else {
          this.formUpdateBankAccount.division = null
          this.optionDivisions = []
        }

        if(modalName == "updateBankAccount") {
            this.modal.updateBankAccount = true;
        }

        if(modalName == "updateIsActive") {
            if(this.bankAccount[index].isActive) {
                this.modal.updateIsActiveToNonActive = true;
            } else {
                this.modal.updateIsActiveToActive = true;
            }
        }
    },
    getBankAccount: function(){
        this.loadingSearch  = true;
        this.bankAccount = []
        let banks = []

        HTTP
            .get('bankAccount/findAll')
            .then(response => {
                this.loadingSearch  = false;

                _.forEach(response.data, function(value) {
                  let divisionName = value.division != null ? value.division.division_name : '';

                  let bank = {
                    id : value.id,
                    accountName : value.accountName,
                    isActive : value.isActive,
                    divisionName : divisionName
                  }

                  banks.push(bank);
                });

                this.bankAccount = banks;
            })
            .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })
    },
    postCreateBankAccount:function(){
            this.loadingCreateBankAccount = true;

            if(this.formBankAccount.accountName.trim() === "") {
                this.$Message.error('Account name tidak boleh kosong');
                this.loadingCreateBankAccount = false;
                return false;
            }

            let accountNameExist = _.some(this.bankAccount, {accountName: this.formBankAccount.accountName });

            if(accountNameExist){
                this.$Message.error('Account name sudah ada');
                this.loadingCreateBankAccount = false;
                return false;
            }

            HTTP
            .post('bankAccount', {
                accountName: this.formBankAccount.accountName,
                division: this.formBankAccount.division,
            })
            .then(response => {
                this.loadingCreateBankAccount = false;
                this.modal.createBankAccount = false;
                this.formBankAccount.accountName = '';

                this.$Message.success('Bank Account Created');
                this.getBankAccount();
            })
            .catch(e => {
                this.loadingCreateBankAccount = false;
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
    },
    postUpdateBankAccount:function(){
            this.loadingUpdateBankAccount = true;

            if(this.formUpdateBankAccount.accountName.trim() === "") {
                this.$Message.error('Account name tidak boleh kosong');
                this.loadingUpdateBankAccount = false;
                return false;
            }

            HTTP
            .post('bankAccount/update', {
                id: this.formUpdateBankAccount.id,
                accountName: this.formUpdateBankAccount.accountName,
                isActive: this.formUpdateBankAccount.isActive,
                division: this.formUpdateBankAccount.division,
            })
            .then(response => {
                this.loadingUpdateBankAccount = false;
                this.modal.updateBankAccount = false;
                this.formUpdateBankAccount.accountName = '';

                this.$Message.success('Bank Account Updateed');
                this.getBankAccount();
            })
            .catch(e => {
                this.loadingUpdateBankAccount = false;
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
    },
    updateIsActive: function() {
        if(this.formUpdateBankAccount.isActive) {
            this.formUpdateBankAccount.isActive = false;
        } else {
            this.formUpdateBankAccount.isActive = true;
        }
        this.postUpdateBankAccount();
    },
    getDivision: function() {
      this.loadingGetDivision = true;
      this.optionDivisions = [];

      HTTP
      .post('division/list')
      .then(response => {
        this.loadingGetDivision = false
        let divisions = response.data.map(function(value) {
          return {
            value: value.id,
            label: value.division_name
          }
        })
        this.optionDivisions = divisions
      }).catch( err => {
        this.loadingGetDivision = false
        this.$Notice.error({
                title: "Error",
                desc: err,
                duration: 5
            });
      })

    }
  },
  created() {
      this.user.username = localStorage.getItem('user.username')
      this.user.role = localStorage.getItem('user.role')
      this.getBankAccount();
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// BankAccount.vue?7f8c79c6